import { render, staticRenderFns } from "./StatistiqueComponent.vue?vue&type=template&id=41b32b35&"
import script from "./StatistiqueComponent.vue?vue&type=script&lang=js&"
export * from "./StatistiqueComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports